function _generateCiiAverageChartOptions(voyageDataForCiiHistory, ciiHistory, ratings) {
  let minY = 0, maxY = 10;

  if (ratings !== null) {
    minY = ratings["aRating"] / 2;
    maxY = ratings["dRating"] * 2;
  }

  const chartOptions = {
    chart: {
      zoomType: "x",
      panning: true,
      panKey: "shift"
    },
    resetZoomButton: {
      position: {
        align: "right",
        verticalAlign: "top",
        x: -10,
        y: 10
      },
      theme: {
        fill: "white",
        stroke: "silver",
        r: 0,
        states: {
          hover: {
            fill: "#41739D",
            style: {
              color: "white"
            }
          }
        }
      }
    },
    credits: {
      enabled: false,
    },
    time: {
      useUTC: true,
    },
    title: {
      text: null,
    },
    yAxis: {
      gridLineWidth: 2,
      max: maxY,
      min: minY,
      title: {
        text: "CO2/gTDW*mile​",
        align: "high",
        style: {
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    xAxis: {
      type: "datetime",

      title: {
        align: "high",
        style: {
          fontSize: "14px",
        },
      },
      labels: {
        format: "{value:%m-%Y}",
        style: {
          fontSize: "12px",
        },
      },
      crosshair: true,
      plotLines: voyageDataForCiiHistory
        ? voyageDataForCiiHistory.map((voyageData) => _generateCiiAveragePlotLine(voyageData)) : [],
    },
    exporting: {
      enabled: false,
    },
    legend: {
      layout: "horizontal",
      align: "right",
      verticalAlign: "top",
      //floating: true
    },
    series: [_generateCiiAverageSeries(ciiHistory, voyageDataForCiiHistory)],
  };
  return chartOptions;
}

function _generateCiiAveragePlotLine(voyageData) {
  return {
    color: voyageData.shortLoadingCondition === "B" ? "var(--average-cii-b-grid-line-color)" : "var(--average-cii-l-grid-line-color)",
    width: 1,
    label: {
      text: `${voyageData.voyageNumber}-${voyageData.voyageLeg}-(${voyageData.shortLoadingCondition})`,
      rotation: 90,
      useHTML: true,
      style: {
        color: voyageData.shortLoadingCondition === "B" ? "var(--average-cii-b-grid-line-color)" : "var(--average-cii-l-grid-line-color)",
        fontWeight: "bold"
      }
    },
    value: voyageData.startDateTimestamp,
  };
}

function _averageCiiBetweenDates(series, startDate, endDate) {
  const startDateTimestamp = new Date(startDate).getTime();
  const endDateTimestamp = new Date(endDate).getTime();

  const ciiValues = series.filter((datum) => {
    return datum.startDateTimestamp >= startDateTimestamp && datum.startDateTimestamp <= endDateTimestamp;
  });

  if (!ciiValues.length) return null;

  const averageCii = ciiValues.reduce((sum, datum) => sum + datum.cii, 0) / ciiValues.length;
  return Number(averageCii.toFixed(2));
}

function _generateCiiAverageSeriesData(series, voyageData) {
  const seriesData = [];
  if (voyageData) {
    for (const voyage of voyageData) {
      if (series) {
        const averageCii = _averageCiiBetweenDates(series, voyage.startDate, voyage.endDate);
        seriesData.push([voyage.startDateTimestamp, averageCii]);
        seriesData.push([voyage.endDateTimestamp, averageCii]);
      }
    }
  }
  return seriesData;
}

function _generateCiiAverageSeries(series, voyageData) {
  return {
    name: "Average CII",
    type: "line",
    colorIndex: 3,
    color: "#DD800E",
    data: _generateCiiAverageSeriesData(series, voyageData),
    visible: true,
    marker: {
      enabled: false,
    },
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
  };
}

export { _generateCiiAverageChartOptions, _generateCiiAverageSeriesData, _generateCiiAveragePlotLine };
